// letter_content_toggle — include/exclude a letter block; pre-ticked from its condition, saved on the appraisal.
import React, { useState } from 'react';
import { ToggleRight } from 'lucide-react';
import { StepCard, StepNav, ErrorLine, readKey, humanise, writeback } from './_stepKit';

export default function LetterContentToggle({ action, value, onChange, onNext, onBack, canBack, capturedData }) {
  const p = action.params || {};
  const condMet = p.condition ? !!readKey(capturedData, p.condition) : true;
  const [on, setOn] = useState(typeof value === 'boolean' ? value : condMet);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const next = async () => {
    setBusy(true); setErr('');
    try { await writeback(capturedData, 'letter_blocks', on, p.block_key); onChange(on); onNext(on); }
    catch (e) { setErr(e?.response?.data?.detail || e.message || 'Save failed'); } finally { setBusy(false); }
  };

  return (
    <div>
      <StepCard icon={ToggleRight} title={`Letter block · ${humanise(p.block_key)}`} testid="wf-letter-toggle">
        {p.condition && (
          <div className="text-xs text-slate-500" data-testid="wf-letter-toggle-condition">
            Condition <code>{p.condition}</code> is <b className={condMet ? 'text-emerald-700' : 'text-amber-700'}>{condMet ? 'met' : 'not met'}</b>
          </div>
        )}
        <label className="flex items-center gap-2 p-3 border border-slate-200 rounded cursor-pointer">
          <input type="checkbox" checked={on} onChange={(e) => { setOn(e.target.checked); onChange(e.target.checked); }} data-testid="wf-letter-toggle-input" />
          <span className="text-sm text-slate-700">Include “{humanise(p.block_key)}” in the letter</span>
        </label>
        <ErrorLine err={err} testid="wf-letter-toggle-err" />
      </StepCard>
      <StepNav canBack={canBack} onBack={onBack} onNext={next} busy={busy} />
    </div>
  );
}
